// extracted by mini-css-extract-plugin
export default {"custom_width":"TaoBienLai_custom_width__Vc8qF"};